// Vite/Rolldown nao injeta os globais do Node.js como o ProvidePlugin do Webpack fazia.
// Fornecemos o pacote `buffer` real (codificacao base64 iterativa via base64-js) em vez
// de um polyfill escrito a mao.
//
// O polyfill inline anterior (no index.html) codificava base64 com
// `btoa(String.fromCharCode.apply(null, bytes))`, passando cada byte como um argumento de
// funcao. Para imagens acima de ~100KB isso estoura o limite de argumentos do motor e lanca
// "Maximum call stack size exceeded" ao salvar logo, capa ou banner (o runtime do sdkgen
// serializa a imagem via `Buffer.prototype.toString("base64")`).
import { Buffer } from "buffer";

globalThis.Buffer = Buffer;
